@import '../../../../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../../../../constants/spacing.module.less';

.table {
  border: 1px solid var(--grey-300);
  background-color: var(--white);
}

.delete-button {
  > svg {
    fill: var(--gray-818F9C);
    width: 14px;
  }
  &:hover {
    > svg {
      fill: var(--gray-212c36);
    }
  }
}

.actions-cell {
  justify-content: center;
}

.product-error-icon {
  width: 14px;
  height: 14px;
  margin-left: @space-8;
  color: var(--red-700);
}

.quantity-received-greater {
  color: var(--green-600);
}

.quantity-received-less {
  color: var(--red-700);
}
